import CuoButton from "@/app/admin/_common/CuoButton";
import { Input } from "@/app/admin/_common/ui/input";
import { Label } from "@/app/admin/_common/ui/label";
import type { AddressValidationResult } from "@/app/_services/LocationService";

export function AddressSuggestionCard({
  geocodeResult,
  typedAddress,
  confirmLabel,
  onConfirm,
  onEdit,
  isSaving,
}: {
  geocodeResult: AddressValidationResult;
  typedAddress: string;
  confirmLabel: string;
  onConfirm: () => void;
  onEdit: () => void;
  isSaving: boolean;
}) {
  const verified = geocodeResult.latitude != null && geocodeResult.longitude != null;

  return (
    <div className="grid gap-4">
      <div>
        <div className="text-[14px] font-semibold text-foreground">Confirm address</div>
        <div className="mt-0.5 text-[12.5px] text-muted-foreground">
          Review the suggested address before continuing.
        </div>
      </div>

      <div className="grid gap-3">
        <Label>What you entered</Label>
        <Input value={typedAddress} disabled />
      </div>

      <div className="grid gap-3">
        <Label>{verified ? "Suggested address" : "Not verified"}</Label>
        <Input
          value={verified ? geocodeResult.formatted_address ?? "" : "We couldn't verify this address"}
          disabled
        />
      </div>

      {geocodeResult.existing_location && (
        <div className="rounded-md border border-amber-200 bg-amber-50 p-3 text-[12.5px] text-amber-800">
          We already have this location:{" "}
          <span className="font-semibold">{geocodeResult.existing_location.name}</span>.
          Continue anyway?
        </div>
      )}

      <div className="flex items-center gap-2">
        <CuoButton
          disableOnAsync={isSaving}
          variant="default"
          onClick={onConfirm}
          label={confirmLabel}
        />
        <CuoButton variant="outline" onClick={onEdit} label="Edit address" />
      </div>
    </div>
  );
}
